<div class="clsNotificationBellOn" [ngClass]="{ small: size === 'small' }">
  <span *ngIf="showNotificationNumber">{{ notificationsNumber }}</span>
</div>
